module.exports = __webpack_public_path__ + "img/menu_phone@3x.1ce8ee10.png";